import { get } from "lodash";

export const extractGalleryImages = (data, fieldConfig) => {
  return data.reduce((acc, item) => {
    let allImages = [];

    fieldConfig.imageFields.forEach((field) => {
      const images = get(item, field, []);
      if (images && images.length) {
        allImages = [...allImages, ...images];
      }
    });

    const id = item._id;

    const imageGalleryData = allImages.map((image) => {
      const metaData = {};

      Object.entries(fieldConfig.metadataFields).forEach(([key, path]) => {
        // hack for gelabs 
        if ((key === "findings" || key === "insights") && image.tags) {
          metaData[key] = get(image.tags, path);
        } else {
          metaData[key] = get(item, path);
        }
      });

      return {
        ...image,
        id,
        metaData,
      };
    });

    return [...acc, ...imageGalleryData];
  }, []);
};
